<template>
  <div class="element-input element-other">
    <div class="body">
      <div class="title on">
        표준 견적서를 받아보실<br>
        다른 보험 종목을 선택하세요.
      </div>
      <div class="label">
        중복 선택이 가능합니다.
      </div>
      <element-checkbox 
        v-model="data.value" 
        :error="have.error" 
        :label="have.label" 
        :items="have.items.filter(o => type.indexOf(o.label) == -1)" class="spread"/>
      <!--<element-content-spread-checkbox :items="est"/>-->
    </div>
  </div>
</template>
<script>
export default {
  props: [ "data", "error", "type" ],
   data() {
    return {
      est: [ 
        { label: "자동차보험",value: "자동차보험" },
        { label: "운전자보험",value: "운전자보험" },
        { label: "실손의료보험",value: "실손의료보험" },
        { label: "암/2대질병 보험",value: "암/2대질병 보험" },
        { label: "어린이보험",value: "어린이보험" },
        { label: "태아보험",value: "태아보험" },
        { label: "정기보험",value: "정기보험"},
        { label: "종신보험",value: "종신보험"},
        { label: "화재보험",value: "화재보험"},
        { label: "연금보험",value: "연금보험"},
        { label: "치아보험",value: "치아보험"},
        { label: "치매보험",value: "치매보험"},
        { label: "펫보험",value: "펫보험" }
      ],
      have: {
        label: "",
        value: "",
        error: "",
        items: [
           { label: "자동차보험",value: "자동차보험" },
          { label: "운전자보험",value: "운전자보험" },
          { label: "실손의료보험",value: "실손의료보험" },
          { label: "암/2대질병 보험",value: "암/2대질병 보험" },
          { label: "어린이보험",value: "어린이보험" },
          { label: "태아보험",value: "태아보험" },
          { label: "정기보험",value: "정기보험"},
          { label: "종신보험",value: "종신보험"},
          { label: "화재보험",value: "화재보험"},
          { label: "연금보험",value: "연금보험"},
          { label: "치아보험",value: "치아보험"},
          { label: "치매보험",value: "치매보험"},
          { label: "펫보험",value: "펫보험" }
        ],
        validations: [
          { type: "array", message: "필수항목입니다" }
        ]
      },
    }
  },
  methods: {
  }
}
</script>
